<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :search-input.sync="search"
    :items="items"
    item-text="name"
    item-value="id"
    :loading="loading"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
  )
    template(v-if="items.length === 0") свободных муниципалитетов нет
</template>

<script>
import { getMunicipalities } from '@/services/API/_common';

export default {
  props: {
    isFree: { type: Boolean, default: false },
    value: { type: [Object, Number], default: null },
    region: { type: Number, required:false, default: null },
    query: { type:Object, required:false, default: () => {} },
    isEmailSettings: { type: Boolean, default: false },
  },
  data() {
    return {
      model: null,
      search: null,
      items: [],
      loading:true,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    async search() {
      // Items have already been requested
      this.loading = true;

      // Lazily load input items
      await this.fetchMuns();
      this.loading = false;
    },
    region() {
      this.fetchMuns();
    },
  },
  created() {
    this.fetchMuns();
  },
  methods:{
    fetchMuns() {
      const params = {
        'search[name]': this.search,
        'search[region_id]':this.region,
        'search[is_free]': this.isFree ? 1 : 0,
        'search[email_setting_is_active]': this.isEmailSettings ? 1 : 0,
        ...this.query,
      };
      if (!this.isFree) delete params['search[is_free]'];
      getMunicipalities(params).then((response) => {
        this.items = response.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
